import React, { useEffect, useRef, useState } from "react";
import "./SupportDetail.scss";

import { FaTrash } from "react-icons/fa";
import { IoIosArrowBack, IoMdSend } from "react-icons/io";
import { MdOutlineSupportAgent } from "react-icons/md";
import { SlOptionsVertical } from "react-icons/sl";
import { FaChevronLeft } from "react-icons/fa6";
import { TfiReload } from "react-icons/tfi";
import { MdOutlineErrorOutline } from "react-icons/md";

import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../../../constants/routes";
import { format } from "date-fns";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import {
  cancelSupportTicket,
  deleteSupportTickets,
  fetchSupportTicketsMessages,
  reOpenSupportTicket,
  sendSupportTicketsMessage,
} from "../../../../api/support";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import echo from "../../../../api/sockets/echo";

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const SupportDetail = ({ selected, reload }) => {
  const formRef = useRef(null);
  const chatRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const supportinfo = selected
    ? selected
    : location.state?.supportDetails || {};

  const { image: userImage, id: user_id } = useSelector(
    (state) => state.userReducer.value
  );

  const [ticketAction, setTicketAction] = useState(null);
  const [openReApply, setOpenReApply] = useState(false);

  const [newMessage, setNewMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (supportinfo?.id) {
      const channel = echo.private(`support.${supportinfo?.id}`);

      channel.listen("MessageSent", (newMessage) => {
        if (
          (newMessage?.message?.id &&
            newMessage?.message?.sender_id !== user_id) ||
          newMessage?.message?.sender === "support"
        ) {
          const messageExists = messages.some(
            (message) => message?.id && message?.id === newMessage?.message?.id
          );

          if (!messageExists) {
            setMessages((prevMessages) => [
              ...prevMessages,
              newMessage?.message,
            ]);
          }
        }
      });

      return () => {
        channel.stopListening("MessageSent");
        echo.leave(`support.${supportinfo?.id}`);
        localStorage.removeItem("socket-token");
      };
    } else {
      localStorage.removeItem("socket-token");
    }
  }, [supportinfo]);

  useEffect(() => {
    if (!supportinfo?.id) {
      navigate(ROUTES.support.path);
    } else {
      setLoading(true);
      fetchSupportTicketsMessages(supportinfo?.id)
        .then((res) => {
          if (res.data?.support_messages?.length > 0) {
            setMessages(res.data?.support_messages);
          } else {
            setMessages([]);
          }
        })
        .catch((err) => {})
        .finally(() => {
          setLoading(false);
        });
    }
  }, [supportinfo]);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  const handleMessageChange = (e) => {
    setNewMessage(e.target.value);
  };

  const handleMessageSubmit = (e) => {
    e.preventDefault();
    if (newMessage && supportinfo?.id) {
      const data = { message: newMessage };
      const tempMessageId = Date.now();

      const newMessageObj = {
        id: tempMessageId,
        sender: "client",
        message: e.target.message.value,
        sending: true,
      };
      setMessages((prevMessages) => [...prevMessages, newMessageObj]);
      setNewMessage("");
      if (formRef.current) {
        formRef.current.reset();
      }

      sendSupportTicketsMessage(supportinfo?.id, data)
        .then((res) => {
          setMessages((prevMessages) => {
            const newMessageArray = prevMessages.map((msg) =>
              msg.id === tempMessageId ? { ...res.data?.new_message } : msg
            );

            if (
              newMessageArray.length === 1 &&
              !newMessageArray.some((msg) => msg.sender === "support")
            ) {
              newMessageArray.push({
                sender: "support",
                message:
                  "Thank you for reaching out to us, our support team will contact you shortly.",
              });
            }

            return newMessageArray;
          });
        })
        .catch(() => {
          setMessages((prevMessages) =>
            prevMessages.map((msg) =>
              msg.id === tempMessageId
                ? { ...msg, sending: false, error: true }
                : msg
            )
          );
        });
    }
  };

  return (
    <div className={`support-details-page ${selected ? "is-model" : ""}`}>
      <div className="container-wrapper support-details">
        <div className="top">
          <p className="title">Your Query</p>
          <p className="sp-title">{supportinfo?.title}</p>
          <span
            dangerouslySetInnerHTML={{ __html: supportinfo?.query_desc }}
          ></span>
        </div>

        <div className="middle">
          <p className="title">Details</p>
          <div className="contents">
            <p>
              <span>Date</span>
              {supportinfo?.created_at
                ? format(supportinfo?.created_at, "dd/MM/yyyy")
                : "dd/MM/yyyy"}
            </p>
            <p>
              <span>Type</span> {supportinfo?.topic}
            </p>
            <p>
              <span>Assistant</span>
              {supportinfo?.assistant || "DAIKOFIN Support Team"}
            </p>
          </div>
          {supportinfo?.status !== "Cancelled" &&
            supportinfo?.status !== "Completed" && (
              <div className="buttons">
                <button
                  type="button"
                  onClick={() => {
                    setTicketAction("cancel");
                  }}
                >
                  Cancel Ticket
                </button>
              </div>
            )}

          {supportinfo?.status === "Cancelled" && (
            <div className="buttons primary">
              <button
                type="button"
                onClick={() => {
                  setOpenReApply(true);
                }}
              >
                Re-Open Ticket
              </button>
            </div>
          )}
        </div>

        <div className="chat-box">
          <div className="upper-container">
            <div className="heading">
              <div className="left">
                <div className="image">
                  {supportinfo?.assistant_image ? (
                    <img
                      src={`${IMAGE_URL}${supportinfo?.assistant_image}`}
                      alt="" aria-label="Support Assistant Image"
                    />
                  ) : (
                    <MdOutlineSupportAgent />
                  )}
                </div>

                <div className="details">
                  <p>{supportinfo?.assistant || "DAIKOFIN Support Team"}</p>
                  <span>Your Assistant</span>
                </div>
              </div>

              <div className="right">
                <SlOptionsVertical />
              </div>
            </div>

            <div className="chat-container" ref={chatRef}>
              {messages?.length > 0 ? (
                <div className="chat-list">
                  {messages?.map((chat, i) => {
                    return (
                      <div
                        className={`message-item ${
                          chat?.sender === "client"
                            ? "right-align"
                            : "left-align"
                        }`}
                        key={i}
                      >
                        <div className="image">
                          {chat?.sender === "client" ? (
                            <img
                              src={
                                supportinfo?.user?.image
                                  ? `${IMAGE_URL}${supportinfo?.user?.image}`
                                  : "/images/profile.svg"
                              }
                              alt="" aria-label={`${
                                supportinfo?.user?.name || "Client"
                              }'s Image`}
                            />
                          ) : (
                            <MdOutlineSupportAgent />
                          )}
                        </div>

                        <p
                          className={`message ${
                            chat?.sending ? "loading" : ""
                          } ${chat?.error ? "loading" : ""}`}
                        >
                          {chat?.message}
                          {chat?.error ? (
                            <span>
                              <MdOutlineErrorOutline />
                              Error: Failed to send message.
                            </span>
                          ) : (
                            <></>
                          )}
                        </p>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="no-messages">
                  {loading ? (
                    <TfiReload />
                  ) : (
                    "Your messages will be displayed here."
                  )}
                </p>
              )}
            </div>
          </div>
          <form ref={formRef} onSubmit={handleMessageSubmit}>
            <input
              type="text"
              placeholder="Message..."
              name="message"
              onChange={handleMessageChange}
            />
            <button
              type="submit"
              className={`send-icon ${newMessage ? "active" : ""}`}
            >
              <IoMdSend />
            </button>
          </form>
        </div>
      </div>
      <div className="navbar-title">#{supportinfo?.ticket_id}</div>

      <CancelDeleteTicket
        open={ticketAction}
        setOpen={setTicketAction}
        ticketId={supportinfo?.id}
        reload={reload}
      />

      <ReApplyTicket
        open={openReApply}
        setOpen={setOpenReApply}
        ticketId={supportinfo?.id}
        reload={reload}
      />

      <div className="ticket-delete-button">
        <FaTrash
          onClick={() => {
            setTicketAction("delete");
          }}
        />
      </div>

      {(ticketAction || openReApply) && (
        <div
          className="blur-back"
          onClick={() => {
            setTicketAction(null);
            setOpenReApply(false);
          }}
        ></div>
      )}
    </div>
  );
};

export default SupportDetail;

const CancelDeleteTicket = ({ open, setOpen, ticketId, reload }) => {
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (open && !ticketId) {
      setOpen(null);
    }
  }, [open, ticketId, setOpen]);

  const handleDelete = () => {
    setSubmitting(true);
    deleteSupportTickets(ticketId)
      .then((res) => {
        toast.dismiss(); toast.success("Ticket deleted successfully.");
        !reload && navigate(ROUTES.support.path);
        reload && reload();
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
        } else {
          toast.dismiss(); toast.error("Error while deleting ticket.");
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleCancel = () => {
    setSubmitting(true);
    cancelSupportTicket(ticketId)
      .then((res) => {
        !reload && navigate(ROUTES.support.path);
        reload && reload();
        toast.dismiss(); toast.success("Ticket canceled successfully.");
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
        } else {
          toast.dismiss(); toast.error("Error while canceling ticket.");
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <div className={`cancel-delete-ticket ${isVisible ? "active" : ""}`}>
      <h1 className="title">
        {open} Ticket #{ticketId}
      </h1>
      <p>
        Are you sure you want to <span>{open}</span> this ticket?
      </p>
      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Confirm"}
          color={"primary"}
          type={"button"}
          handleSubmit={() => {
            if (open === "delete") {
              handleDelete();
            } else {
              handleCancel();
            }
          }}
          disabled={submitting}
          loader={submitting}
        />
      </div>
    </div>
  );
};

const ReApplyTicket = ({ open, setOpen, ticketId, reload }) => {
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (open && !ticketId) {
      setOpen(false);
    }
  }, [open, ticketId, setOpen]);

  const handleTicketReApply = () => {
    setSubmitting(true);
    reOpenSupportTicket(ticketId)
      .then((res) => {
        toast.dismiss(); toast.success("Ticket re-opened successfully.");
        !reload && navigate(ROUTES.support.path);
        reload && reload();
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
        } else {
          toast.dismiss(); toast.error("Error while re-opening ticket.");
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <div className={`cancel-delete-ticket ${isVisible ? "active" : ""}`}>
      <h1 className="title">Re-Open Ticket #{ticketId}</h1>
      <p>Are you sure you want to re-open this ticket?</p>
      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Confirm"}
          color={"primary"}
          type={"button"}
          handleSubmit={handleTicketReApply}
          disabled={submitting}
          loader={submitting}
        />
      </div>
    </div>
  );
};
